export default __webpack_public_path__ + "static/media/group-189@2x.9d6ea5ed.png";